/**
 * Created by vetal on 15.11.16.
 */
define('plugin/gallery/GalleryPlugin',['require','lib/plugin/PluginAbstract','plugin/gallery/controller/GalleryController','plugin/gallery/collection/GalleryCollection','plugin/gallery/view/GalleryModuleIndexView','lib/AppRouter'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var GalleryController = require('plugin/gallery/controller/GalleryController');
    var GalleryCollection = require('plugin/gallery/collection/GalleryCollection');
    var GalleryModuleIndexView = require('plugin/gallery/view/GalleryModuleIndexView');
    var AppRouter = require('lib/AppRouter');

    return PluginAbstract.extend({

        _collection : null,
        _galleryModuleRegions: {
            gallery: '#sb_gallery'
        },
        _moduleView: null,

        initialize: function () {
            // code created by Vitaly. Fixed by dimka, to not load reviews when it not needed
            this._collection = new GalleryCollection();

            var galleryRouter = new AppRouter({
                appRoutes: {
                    'gallery': 'index',
                    /*'gallery/:id': 'view'*/
                },
                menuItem: 'gallery',
                controller: new GalleryController({
                    app: this.getOption('app'),
                    galleryCollection : this._collection
                })
            });
        },

        initModules: function (view) {
            _.each(this._galleryModuleRegions, function (selector, galleryModuleRegion) {
                view.addRegion(galleryModuleRegion, selector);
            });

            if (view.gallery.$el.length) {
                if (!this._moduleView || this._moduleView.isDestroyed) {
                    this._moduleView = new GalleryModuleIndexView({
                        collection : this._collection
                    });

                    this._collection.load();
                }
                view.gallery.show(this._moduleView);
            }
        }
    });

});
